import { Box, Modal, Step, StepLabel, Stepper, Typography, useMediaQuery } from "@mui/material"
import dayjs from 'dayjs'; // Ensure you have dayjs installed for date formatting

const OpportunityLogsModal = ({logs, open, handleClose}) => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const isLaptop = useMediaQuery('(max-width:1280px)')

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? '85vw' : isLaptop ? '60vw' : '30vw',
        bgcolor: 'background.paper',
        border: '2px solid #5b6b79',
        borderRadius: "10px",
        boxShadow: 24,
        p: 4,
        overflowY: 'auto', // Scroll if needed
        maxHeight: '80vh' // Prevents overflowing the viewport
    }

    const CustomStepIcon = ({ icon }) => {
        return (
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              backgroundColor: '#1976d2',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 12,
              fontWeight: 'bold'
            }}
          >
            {icon}
          </Box>
        );
      };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box className="hive-single-quote-logs-modal" sx={style}>
                <Typography className="hive-single-quote-logs-title" variant="h6" component="h2">Opportunity logs</Typography>
                <Stepper className="hive-single-quote-logs-stepper" activeStep={0} orientation="vertical">

                {logs.map((log, index) => {
                    const displayNumber = logs.length - index;

                    return (
                        <Step className="hive-single-quote-logs-step" key={log._id}>
                            <StepLabel className="hive-single-quote-logs-step-label" StepIconComponent={() => <CustomStepIcon icon={displayNumber} />}>
                                <Typography className="hive-single-quote-logs-description" variant="body1">{log.description}</Typography>
                                <Typography className="hive-single-quote-logs-meta" variant="caption" color="textSecondary">
                                    {dayjs(log.createdAt).format('MMMM D, YYYY [at] h:mm A')}
                                </Typography>
                                <Box className="hive-single-quote-logs-user-wrap" sx={{ mb: 0.5 }}>
                                    <Typography className="hive-single-quote-logs-meta" variant="caption" color="textSecondary">
                                        {[log.user?.firstName, log.user?.lastName].filter(Boolean).join(' ') || 'Unknown user'}
                                    </Typography>
                                </Box>
                            </StepLabel>
                        </Step>
                    );
                })}

                </Stepper>
            </Box>
        </Modal>
    )
}

export default OpportunityLogsModal
